import { get } from "../../utils";

export const authParam = function (props) {
  const _auth = get(props, "_auth", null);
  const globalAuthList = get(window, "_authList", null);
  if (_auth != null && globalAuthList instanceof Array) {
    const auth = globalAuthList.find((item) => get(item, "auth", "") === _auth);
    return auth;
  }
  return null;
};

/**
 * 计算该元素是否应该显示
 *
 * @param {*} props
 * @returns
 */
export const showComponent = function (props, auth_) {
  const auth = auth_ || authParam(props);
  const globalAuthList = get(window, "_authList", null);
  const _auth = get(props, "_auth", null);
  if (_auth == null) {
    return true;
  } else if (globalAuthList instanceof Array && auth == null) {
    return false;
  } else {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxComponent/tools.js